import React from 'react';
import { Box, ButtonProps, withStyles } from '@material-ui/core';
import FsBody from 'ui-elements/typography/FsBody';
import { TypographyAllProps } from 'globals/types';
import FsButton from 'ui-elements/buttons/FsButton';

export const Paragraph = withStyles(() => ({
  root: {},
}))(FsBody);

export const Strong = withStyles(() => ({
  root: {
    fontWeight: 600,
  },
}))((props: TypographyAllProps) => <FsBody {...props} component="span" />);

export const ButtonWrapperBox = withStyles(({ spacing }) => ({
  root: {
    marginTop: spacing(2),
  },
}))(Box);

export const ActionButton = withStyles(() => ({}))((props: ButtonProps) => (
  <FsButton {...props} variant="outlined" color="primary" minWidth={160} />
));
